import { useEffect, useState } from 'react';
import { RECORDER_STATUS_EVENT, RecorderStatusDetail, getRecorderStatusSnapshot } from '../utils/recorderEvents';

const defaultStatus: RecorderStatusDetail = {
    isRecording: false,
    isPaused: false,
    isUploading: false,
    uploadProgress: 0,
    recordingTime: 0,
    statusMessage: ''
};

const useRecorderStatus = () => {
    const [status, setStatus] = useState<RecorderStatusDetail>(() => {
        const snapshot = getRecorderStatusSnapshot();
        return snapshot ?? defaultStatus;
    });

    useEffect(() => {
        const handleStatusUpdate = (event: Event) => {
            const customEvent = event as CustomEvent<RecorderStatusDetail>;
            setStatus(customEvent.detail);
        };

        window.addEventListener(RECORDER_STATUS_EVENT, handleStatusUpdate);
        return () => {
            window.removeEventListener(RECORDER_STATUS_EVENT, handleStatusUpdate);
        };
    }, []);

    return status;
};

export default useRecorderStatus;
